import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RIEInput } from 'riek';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import deep from 'deep-diff';
import JSON_TRANSFORM from '../../../utils/jsonTransform/jsonTransformers';
import MANAGED_UX_FORMS_CONTROLLER from '../../../controllers/managedUxForms';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
import { useReadOnly } from '../../../contexts/ReadOnlyContext';
import BoxDescription from './BoxDescription';

const FORM_NAME = 'VAT_RETURNS_BOX_VALUES';

const log = new Logger('VAT_RETURN_BOX', LOG_LEVELS.ERROR);

export class VatReturnBox extends Component {

  constructor(props) {
    super(props);
    this.handleRIEFieldChange = this.handleRIEFieldChange.bind(this);
  }
  render() {
    log.debug('render(): ', this.props);
    const box = this.props.box || {};
    if (!box) {
      return (<tr></tr>);
    }
    const boxValue = Number.parseFloat(box.boxValue);
    const formattedValue = (Number.isNaN(boxValue) ? (0.0) : boxValue).toFixed(2);
    
    // Use isReadOnly from context via props
    const isEditable = this.props.isEditable === "true" && !this.props.isReadOnly;
    
    return (
      <tr data-test="component-vat-return-box">
        <td>
          <BoxDescription
            id={`${box.boxType}-${box.boxName}`}
            description={this.props.boxDescription}
            enableInlineDescription={this.props.enableInlineDescription}
          >
            <a data-test="vat-return-box-name" className={this.props.boxAsLink ? "tertiary" : ""} onClick={this.props.loadBoxDetail}>
              {box.boxName}
            </a>
          </BoxDescription>
        </td>
        <td className={withFullStoryExclude("text-align-right")}>
          <span>
            {isEditable ? (
              <RIEInput
                propName={formattedValue}
                value={formattedValue}
                change={this.handleRIEFieldChange(box)}
                classEditing="editing width-auto"
                className="editable text-align-right"
              />

            ) : (
                <span data-test="vat-return-box-value">{formattedValue}</span>
              )}
          </span>
        </td>
      </tr>
    );
  }

  handleRIEFieldChange(box) {
    return (data) => {
      const updatedValue = Number.parseFloat(Object.values(data)[0]);
      const formattedValue = (Number.isNaN(updatedValue) ? (0.0) : updatedValue).toFixed(2);
      this.props.onBoxValueChange(box, formattedValue);
      this.doFieldChange(box, formattedValue);
    }
  }

  handleJsonViewerChange(data) {
    log.debug('handleJsonViewerChange: ', data)
    const diff = deep(data.existing_src, data.updated_src);
    let value = diff[0].rhs;
    let key = 'errorJson.ReportingDocument.'
    key += JSON_TRANSFORM.arrayToFlatReference(diff[0].path);
    this.doFieldChange(key, value);
  }

  doFieldChange(key, value) {
    log.debug('doFieldChange: key: %s value: ', key, value);
    if (typeof this.props.onFieldChange === 'function') {
      this.props.onFieldChange(key, value);
    }
    if (typeof this.props.onStructuredFieldChange === 'function') {
      this.props.onStructuredFieldChange(key, value);
    }
  }


}

function mapDispatchersToProps(dispatch) {
  return {
    // Standard form actions
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    }
  }
}


// Which props do we want to inject, given the global state?
export function mapStateToProps(state) {

  return {
    languages: state.languages,

  };
}


VatReturnBox.defaultProps = {
  boxAsLink: true,
  onBoxValueChange: () => { },
  enableInlineDescription: false,
}

// Wrapper component that uses the ReadOnly context
const VatReturnBoxWithReadOnly = (props) => {
  const { isReadOnly } = useReadOnly();
  return <VatReturnBox {...props} isReadOnly={isReadOnly} />;
};

// Wrap the component to inject dispatch and state into it
const ConnectedVatReturnBox = connect(mapStateToProps, mapDispatchersToProps)(VatReturnBoxWithReadOnly);
export default ConnectedVatReturnBox;
